// Flag to control schedule mapping strategy in Scheduling Tool.
// - true: keep existing client-side mapping of departments/employees.
// - false: use sidebar_list_v4 API to drive layout + mapping.
export const useLegacySchMapping = false;
